<template>
  <div class="take-photo-skeleton">
    <el-skeleton style="width: 100%" animated>
      <template #template>
        <el-skeleton-item
          variant="rect"
          style="width: 100%; --el-skeleton-color: #8D9EA8"
        ></el-skeleton-item>
      </template>
    </el-skeleton>
    <div style="text-align: center; padding: 30px 15px; color: #AFBEC7">
      Processing video ...
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="sass" scoped>
  .take-photo-skeleton
    width: 100vw
    height: 100vh
    position: fixed
    top: 0
    left: 0
    z-index: 10000
    background-color: #2C353B
    padding: 85px 20px 20px
::v-deep(.el-skeleton__rect)
  padding-bottom: 165%
  border-radius: 0
</style>
